import React from "react";
import { CgClose } from "react-icons/cg";
import styles from "./close-btn.module.scss";
import classNames from "classnames";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: "dark" | "light";
}

const ModularCloseBtn = ({ color = "dark", ...buttonProps }: Props) => {
  return (
    <button {...buttonProps} className={classNames(styles.closeBtn, styles[color])}>
      <CgClose size={18} />
    </button>
  );
};

export default ModularCloseBtn;
